/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ExtraChargeType, MarkupBuilder, OfferProduct} from 'compob2b-libs';

export class RestorePriceStrategy implements MarkupBuilder {
  apply(price: number, value: number): number {
    return price + value;
  }

  applyAll(products: OfferProduct[], value: number): Map<number, number> {
    const map = new Map<number, number>();
    products.forEach(item => {
      const price = item.cartProduct.commercePrice === null ?
        item.cartProduct.price : item.cartProduct.commercePrice.price;

      map.set(item.cartProduct.id, this.apply(price, 0));
    });

    return map;
  }

  getType(): ExtraChargeType {
    return ExtraChargeType.RESTORE_PRICE;
  }

}
